export interface OAuthResult {
  success: boolean;
  error?: string;
}

/**
 * Opens an OAuth URL by redirecting the current page.
 * On web, this performs a full page navigation.
 */
export async function openOAuthUrl(url: string): Promise<OAuthResult> {
  // On web, we redirect the entire page
  window.location.href = url;
  // This won't actually return since we're navigating away
  return {success: true};
}

/**
 * Opens a URL in a new browser window/tab.
 */
export async function openBrowserUrl(url: string, _closeOnUrls?: string[]): Promise<OAuthResult> {
  const popup = window.open(url, '_blank');
  if (!popup) {
    return {success: false, error: 'popup_blocked'};
  }
  return {success: true};
}

/**
 * Close browser - no-op on web
 */
export function closeBrowser(): void {
  // No-op on web
}
